//import logo from './logo.svg';//
import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <h1>Weather App</h1>
        <Weather defaultCity="London" />
        <footer>
          This is coded by{" "}
          <a
            href="https://github.com/SheillaO"
            target="_blank"
            rel="noopener noreferrer"
          >
            Olga
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/SheillaO/weather-forecast-react-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://weather-forecast-react-app-dashboard.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}
